import moment from "moment";
import React from "react";
import dummmyImg from "../../../images/profile/images1.png";
import { useDispatch, useSelector } from "react-redux";
import { selectConversationForChat } from "../../../store/actions/SessionActions";
import BadgeWithoutBg from "../../../images/diamond.svg";

function ChatCard({
  updatedAt,
  lastMessage,
  conversationData,
  unreadCount,
  userName,
  image,
  id,
  isPremium,
  gender,
  className, // Added className prop
}) {
  const dispatch = useDispatch();
  const selectedConversation = useSelector(
    (state) => state.session.selectedConversationDetails
  );

  function handleSelectConversation() {
    dispatch(
      selectConversationForChat({
        conversationId: conversationData?._id,
        name: userName,
        image: image,
        Id: id,
      })
    );
  }

  function capitalizeFirstLetterOfFirstWord(phrase) {
    if (phrase?.length === 0) return phrase;
    return phrase?.charAt(0).toUpperCase() + phrase?.slice(1);
  }

  function formatMessageTime(timestamp, showTodayLabel = false) {
    const messageDate = moment(timestamp);
    const today = moment();
    const yesterday = moment().subtract(1, "days");

    const dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    // Today
    if (messageDate.isSame(today, "day")) {
      return showTodayLabel ? "Today" : messageDate.format("HH:mm");
    }

    // Yesterday
    if (messageDate.isSame(yesterday, "day")) {
      return "Yesterday";
    }

    // Within the last 7 days
    if (messageDate.isAfter(moment().subtract(7, "days"))) {
      return dayNames[messageDate.day()];
    }

    // Older dates
    return messageDate.format("DD/MM/YYYY");
  }

  return (
    <div
      className={`chat-card p-3 chat-card-hover ${className} ${
        selectedConversation?.conversationId === conversationData?._id &&
        "selected-chat"
      }`}
      onClick={handleSelectConversation}
    >
      <div className="d-flex align-items-center w-100">
        {/* Left: Profile Image */}
        <img
          src={
            image?.url
              ? "" + image?.url
              : dummmyImg
          }
          alt="User"
          className="rounded-circle object-fit-cover"
          style={{ width: "48px", height: "48px", marginRight: "15px" }}
        />

        {/* Middle: Name + Last Message */}
        <div className="flex-grow-1">
          <div className="fw-semibold text-dark text-capitalize">
            {capitalizeFirstLetterOfFirstWord(userName)}
            {isPremium && gender === "female" && (
              <img src={BadgeWithoutBg} alt="" className="w-[24px]" />
            )}
          </div>
          <div
            className="text-muted small text-truncate"
          >
            {lastMessage.substring(0, 20)}
            {lastMessage.length > 20 && "..."}
          </div>
        </div>

        {/* Right: Time + Unread Badge */}
        <div className="text-end ms-3">
          <div className="text-muted small">{formatMessageTime(updatedAt)}</div>
          {unreadCount > 0 && (
            <span className="badge bg-primary mt-1">{unreadCount}</span>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChatCard;
